import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ element }) => {
  const { token, autoLoginAttempted } = useSelector((state) => state?.user);

  // Show loading while auto-login is being attempted
  if (!autoLoginAttempted) {
    return (
      <div className="pt-3 text-center">
        <div className="sk-spinner sk-spinner-pulse"></div>
      </div>
    );
  }

  return token ? element : <Navigate to="/" replace />;
};

export default ProtectedRoute;
